/* Generated. This file cannot be edited directly. Please check codegen-subscription.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/subscriptionTypes'

const defaultOptions = {} as const
export type VehicleGuidanceSessionUpdatesSubscriptionVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type VehicleGuidanceSessionUpdatesSubscription = {
  __typename?: 'Subscription'
  sdsGuidanceSessionUpdates: {
    __typename?: 'SDSGuidanceSessionUpdate'
    openIssue: {
      __typename?: 'SDSGuidanceIssue'
      id: string
      status: Types.SdsGuidanceIssueStatus
      failureReason: Types.SdsGuidanceFailureReason | null
      situation: {
        __typename?: 'SDSGuidanceSituation'
        type: Types.SdsGuidanceSituationType | null
        other: {
          __typename?: 'SDSGuidanceSituationTypeOther'
          name: string
          description: string
        } | null
      }
      decisionOptions: Array<{
        __typename?: 'SDSGuidanceDecision'
        maneuver: Types.SdsGuidanceManeuver | null
        other: {
          __typename?: 'SDSGuidanceManeuverOther'
          id: string
          description: string
        } | null
      }>
    } | null
    issues: Array<{
      __typename?: 'SDSGuidanceIssue'
      id: string
      status: Types.SdsGuidanceIssueStatus
    }>
  }
}

export const VehicleGuidanceSessionUpdatesDocument = gql`
    subscription VehicleGuidanceSessionUpdates($vehicleId: ID!) {
  sdsGuidanceSessionUpdates(vehicleId: $vehicleId) {
    openIssue {
      id
      status
      situation {
        type
        other {
          name
          description
        }
      }
      decisionOptions {
        maneuver
        other {
          id
          description
        }
      }
      failureReason
    }
    issues {
      id
      status
    }
  }
}
    `

/**
 * __useVehicleGuidanceSessionUpdatesSubscription__
 *
 * To run a query within a React component, call `useVehicleGuidanceSessionUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVehicleGuidanceSessionUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleGuidanceSessionUpdatesSubscription({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useVehicleGuidanceSessionUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    VehicleGuidanceSessionUpdatesSubscription,
    VehicleGuidanceSessionUpdatesSubscriptionVariables
  > &
    (
      | {
          variables: VehicleGuidanceSessionUpdatesSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    VehicleGuidanceSessionUpdatesSubscription,
    VehicleGuidanceSessionUpdatesSubscriptionVariables
  >(VehicleGuidanceSessionUpdatesDocument, options)
}
export type VehicleGuidanceSessionUpdatesSubscriptionHookResult = ReturnType<
  typeof useVehicleGuidanceSessionUpdatesSubscription
>
export type VehicleGuidanceSessionUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<VehicleGuidanceSessionUpdatesSubscription>
